import React, { useState } from 'react';
import { useLocation } from 'react-router';
import UserReadyPlaceHolder from './userReadyPlaceHolder';

interface LoadingPlaceholderProps {
    text?: string;
    size?: 'small' | 'default' | 'large';
    fullScreen?: boolean;
}

const LoadingPlaceholder: React.FC<LoadingPlaceholderProps> = ({
    size = 'default',
    fullScreen = false
}) => {

    const [userIsReady, setUserIsReady] = useState<boolean>(false);

    const { pathname } = useLocation();
    if (pathname !== "/") {
        return null;
    }

    // Show UserReadyPlaceHolder while the user environment is being prepared
    if (!userIsReady) {
        return <UserReadyPlaceHolder 
            size={size} 
            fullScreen={fullScreen}
            onUserReady={() => setUserIsReady(true)}
        />;
    }

    return null;
};

export default LoadingPlaceholder;